
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Aktuellt',

    metaInfo: { title: 'Aktuellt' },

    extends: View,

    mixins: [
      LoadSections([
        'hotellet',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'aktuellt',
      },
    },
  }
</script>
